import React from 'react';
import { Table, TableHeader, TableRow, TableHeading, TableBody } from '@insurancemenu/imenu-components-lib';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import clsx from 'clsx';
import { createStyles } from '../UploadFilesTable/styles';
import UploadFilesRow from './UploadFilesRow';

const UploadFilesTable = observer((): JSX.Element => {
  const classes = createStyles();
  const {
    uploadSyncFilesStore: { loading, fileUploads },
  } = useRootStore();

  const convertedData = fileUploads.map((file) => toJS(file)).slice();

  const rowsList: JSX.Element[] = convertedData.map((upload) => {
    return <UploadFilesRow key={upload.id} fileUpload={upload} />;
  });

  return (
    <>
      <p className={classes.quantity}>
        Quantity: <b>{convertedData.length}</b>
      </p>
      <div className={classes.tableWrapper}>
        <Table
          className={classes.table}
          loading={loading}
          totalElements={convertedData.length}
          minHeight="50rem"
          maxHeight="50rem"
          showScrollShadows
        >
          <TableHeader className={classes.tableHeader}>
            <TableRow>
              <TableHeading className={classes.tableHeading}>File Name</TableHeading>
              <TableHeading className={classes.tableHeading}>Sponsor Id</TableHeading>
              <TableHeading className={classes.tableHeading}>Step</TableHeading>
              <TableHeading className={classes.tableHeading}>File type</TableHeading>
              <TableHeading className={classes.tableHeading}>Date of upload</TableHeading>
              <TableHeading width="10rem" className={clsx(classes.tableHeading, classes.dropdownColumn)}>
                Links
              </TableHeading>
              <TableHeading width="10rem" className={clsx(classes.tableHeading, classes.dropdownColumn)}>
                Actions
              </TableHeading>
            </TableRow>
          </TableHeader>
          <TableBody className={classes.tableBody}>{rowsList}</TableBody>
        </Table>
      </div>
    </>
  );
});

export default UploadFilesTable;
